<template>
  <div class="selector">
    <van-field
      :value="fieldValue"
      readonly
      right-icon="arrow-down"
      @click="toggolePickerHandler"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns()"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Selector',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
      default: ''
    },
    columns: {
      type: Function,
      default: () => {},
      required: false
    }
  },
  data: () => ({
    showPicker: false
  }),
  computed: {
    fieldValue () {
      return this.value
    }
  },
  methods: {
    toggolePickerHandler () {
      this.showPicker = true
    },
    onConfirm (value, index) {
      console.log(value, index)
      this.showPicker = false
      this.$emit('change', value)
    },
    // onChange (picker, value, index) {
    //   this.$emit('change', value)
    // },
    onCancel () {
      this.showPicker = false
      // this.$emit('change', undefined)
    }
  }
}
</script>

<style scoped lang="scss">
.selector {
  .van-field {
    border: 1px solid $color-text-light;
    border-radius: 4px;
    padding: 5px 16px;
  }
}
</style>
